function initMobileMenu() {
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('menu-overlay');

  if (!menuToggle || !mobileMenu) {
    console.warn('Mobile menu elements not found on', window.location.pathname);
    return;
  }

  function openMenu() {
    mobileMenu.classList.add('active');
    if (overlay) overlay.classList.add('active');
    menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    mobileMenu.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    menuToggle.setAttribute('aria-expanded', 'false');
  }

  function toggleMenu(e) {
    e.preventDefault();
    e.stopPropagation();

    const isOpen = mobileMenu.classList.contains('active');

    if (isOpen)
      closeMenu();
    else
      openMenu();
  }

  // Toggle menu on button click
  menuToggle.addEventListener('click', toggleMenu);

  // Close menu when clicking overlay
  if (overlay)
    overlay.addEventListener('click', closeMenu);

  // Close menu when clicking menu items
  const menuLinks = mobileMenu.querySelectorAll('a');
  menuLinks.forEach(link => link.addEventListener('click', closeMenu));

  // Close menu when clicking outside of menu
  document.addEventListener('click', e => {
    if (
      mobileMenu.classList.contains('active') &&
      !mobileMenu.contains(e.target) &&
      !menuToggle.contains(e.target)
    )
      closeMenu();
  });
}

if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', initMobileMenu);
else
  initMobileMenu();
